import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from '../../../services/customer.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.css']
})
export class ChangeStatusComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  user_status: string;
  statusTo: string;
  user_id: any;
  constructor(
    private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: number,
     private userService: UserService,
      private customerService: CustomerService) { }

  ngOnInit() {
    this.user_status = this.data['user'].status;
    console.log(this.user_status);
    this.user_id = this.data['user'].user.id;
    console.log(this.user_id);
    if (this.user_status === 'ACTIVE') {
      this.statusTo = 'INACTIVE';
    } else {
      this.statusTo = 'ACTIVE';
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.userService.changeUserStatus(this.statusTo , this.user_id )
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}